import React from "react";
import UserStore from "../../stores/UserStore";
import Modal from "react-modal";
import Can from "../authentication/Can";
import SubmitButton from "../reusableComponents/SubmitButton";
import InputField from "../reusableComponents/InputField";
import { Multiselect } from "react-widgets";
import Table from "../reusableComponents/ReactTable";
import UserEditForm from "./UserEditForm";
import { alertService } from "../common/alert.service";

class AccountManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loadedUsers: false,
      addDisabled: false,
      newUsername: "",
      newCustomerEmployeeFirstName: "",
      newCustomerEmployeeLastName: "",
      newCustomerEmployeeTitle: "",
      newCustomerEmployeeEmail: "",
      newCustomerEmployeePhoneNumber: "",
      roles: [],

      usersColumns: [
        { Header: "Username", accessor: "username" },
        { Header: "Email", accessor: "email" },
        {
          Header: "Permissions",
          accessor: (data) => {
            let output = [];
            data.permissions.forEach((perm) => {
              output.push(perm.name);
            });
            return output.join(", ");
          },
        },
      ],
    };
  }

  async componentDidMount() {
    this.getUsers();
    this.getPermissions();
  }

  async getPermissions() {
    if (!UserStore.isLoggedIn || !UserStore.username) {
      return;
    }
    try {
      let res = await fetch("/getPermissions", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      let result = await res.json();
      if (result && result.success) {
        this.setState({
          roles: result.permissions,
        });
      } else if (result && result.success === false) {
      }
    } catch (e) {
      console.log(e);
    }
  }

  setInputValue(property, val) {
    this.setState((previous) => {
      const next = { ...previous, [property]: val };
      return {
        [property]: val,
        newUsername: (next.newCustomerEmployeeFirstName.trim().charAt(0) +
          next.newCustomerEmployeeLastName.trim()).toLowerCase(),
      };
    });
  }

  async addUser() {
    if (this.state.addDisabled) return;
    const fields = ["FirstName", "LastName", "Title", "Email", "PhoneNumber"];
    if (["FirstName", "LastName", "Email"].some((field) => !this.state["newCustomerEmployee" + field].trim()) ||
        !this.state.newPermissions || !this.state.newPermissions.length) {
      alertService.warn("Please enter first name, last name, email, and select at least one permission.");
      return;
    }
    this.setState({ addDisabled: true });
    try {
      const res = await fetch("/addUser", {
        method: "post",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName: this.state.newCustomerEmployeeFirstName.trim(),
          lastName: this.state.newCustomerEmployeeLastName.trim(),
          title: this.state.newCustomerEmployeeTitle.trim(),
          email: this.state.newCustomerEmployeeEmail.trim(),
          phoneNumber: this.state.newCustomerEmployeePhoneNumber.trim(),
          permissions: this.state.newPermissions,
        }),
      });
      const result = await res.json();
      if (result.success) {
        this.setState({
          newUsername: "", newPermissions: [],
          ...Object.fromEntries(fields.map((field) => ["newCustomerEmployee" + field, ""])),
        });
        await this.getUsers();
        alertService.success("Successfully created user!");
      } else {
        alertService.error(result.msg);
      }
    } catch (e) {
      alertService.error("Unable to create the user. Please try again.");
    } finally {
      this.setState({ addDisabled: false });
    }
  }

  async getUsers() {
    if (!UserStore.isLoggedIn || !UserStore.username) {
      return;
    }
    try {
      let res = await fetch("/getUsers", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          users: result.users,
          loadedUsers: true,
        });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async selectUser(index) {
    this.setState({ openModal: true, selectedUser: this.state.users[index] });
  }

  render() {
    if (!this.state.loadedUsers) {
      return (
        <div className="app">
          <h1>Loading...</h1>
        </div>
      );
    }
    return (
      <div className="app">
        <div className="container2">
          <div className="box panel extraWide">
            <h2>Users:</h2>
            <Table
              columns={this.state.usersColumns}
              data={this.state.users}
              getRowProps={(row) => ({
                className: "clickable",
                //onClick: () => this.selectUser(row.index),temporarily disable 
              })}
            />
          </div>
          <div className="panel">
            <h1 className="descriptor">
              The account manager page can be used to manage all website users
              and create new ones. On the left is a list of users. Depending on
              what permissions you have you may see additional content on this
              page.
            </h1>
            <Can
              role={UserStore.permissions}
              perform="users:add"
              yes={() => (
                <form className="box center" onSubmit={(event) => {
                  event.preventDefault();
                  this.addUser();
                }}>
                  <h2>New User</h2>
                  <p>Enter the name and email and select permissions. Title and phone are optional.</p>
                  {[
                    ["FirstName", "First Name", "text"],
                    ["LastName", "Last Name", "text"],
                    ["Title", "Title", "text"],
                    ["Email", "Email", "email"],
                    ["PhoneNumber", "Phone Number", "tel"],
                  ].map(([field, label, type]) => (
                    <label key={field}>
                      {label}:
                      <InputField
                        required={["FirstName", "LastName", "Email"].includes(field)}
                        type={type}
                        value={this.state["newCustomerEmployee" + field]}
                        disabled={this.state.addDisabled}
                        onChange={(value) => this.setInputValue("newCustomerEmployee" + field, value)}
                        onKeyDown={() => {}}
                      />
                    </label>
                  ))}
                  <label>
                    Username:
                    <InputField
                      type="text"
                      value={this.state.newUsername}
                      readOnly
                      onChange={() => {}}
                      onKeyDown={() => {}}
                    />
                  </label>
                  Permissions:
                  <Multiselect
                    data={this.state.roles}
                    textField="name"
                    value={this.state.newPermissions || []}
                    disabled={this.state.addDisabled}
                    onChange={(value) => this.setState({ newPermissions: value })}
                  />
                  <button className="btn" type="submit" disabled={this.state.addDisabled}>
                    {this.state.addDisabled ? "Creating User..." : "Add User"}
                  </button>
                </form>
              )}
              no={() => {}}
            />
          </div>
        </div>

        <Modal
          className="popup"
          isOpen={this.state.openModal}
          onRequestClose={() => {
            this.setState({ openModal: false });
          }}
        >
          <div className="app container">
            <UserEditForm user={this.state.selectedUser} />
            <SubmitButton
              text="Close"
              onClick={() => {
                this.setState({ openModal: false });
              }}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default AccountManager;
